export { BykoMainLogo } from "./byko-main-logo";
